function Valores() {
    return (
        <section className="valores-sec">
            <div className="wrap">
                <div className="valores-card">
                    <div className="sec-title">
                        <h2>Nuestros valores</h2>
                        <div className="bar"></div>
                    </div>

                    <div className="val-grid">
                        <div className="val-item">
                            <span className="val-ic">
                                <i className="fas fa-bullseye"></i>
                            </span>
                            <b>Precisión</b>
                        </div>

                        <div className="val-item">
                            <span className="val-ic">
                                <i className="fas fa-shield-halved"></i>
                            </span>
                            <b>Confidencialidad</b>
                        </div>

                        <div className="val-item">
                            <span className="val-ic">
                                <i className="far fa-clock"></i>
                            </span>
                            <b>Puntualidad</b>
                        </div>

                        <div className="val-item">
                            <span className="val-ic">
                                <i className="fas fa-user-tie"></i>
                            </span>
                            <b>Profesionalismo</b>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Valores;